import React, { useContext, useState } from "react";
import { TableHead } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";

function MaterialForm(props) {
  const {
    selectedCountry,
  } = useContext(Context);

  var style = {
    padding: 0.6,
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ overflow: "auto"}}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.formula.tableHeader.tipo}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.formula.tableHeader.posicao}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.formula.tableHeader.ordemMaterial}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.formula.tableHeader.codMaterial}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.formula.tableHeader.material}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!props.sagA_material &&
            props.sagA_material.map((eachObj, index) => (
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" sx={style}>
                  {eachObj.ARMAZEM}
                </TableCell>
                <TableCell sx={style}>{eachObj.POS_RESERVA} </TableCell>
                <TableCell sx={style}>{eachObj.ORDEM_MATERIAL} </TableCell>
                <TableCell sx={style}>{eachObj.COD_MATERIAL} </TableCell>
                <TableCell sx={style}>{eachObj.MATERIAL} </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default MaterialForm;
